import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export default function CompactResult({ result, date, loading = false }) {
  const numbers = result?.numbers || [];

  return (
    <div className={`tt04-sidebar-kq${loading ? " is-loading" : ""}`}>
      {loading || !result ? (
        <div className="xoso-sidebar-kq__empty">
          {loading ? "" : `Chưa có KQ ${dayjs(date).format("DD/MM")}`}
        </div>
      ) : (
        <ul className="tt04-sidebar-balls">
          {numbers.map((n, i) => (
            <li key={`${n}-${i}`} className="tt04-sidebar-ball">
              {n}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
